<div class="column-container container">
  <div class="header-container border-bottom center-container space-between">
    <div i18n>商品資訊</div>
    <button appFocusRemove mat-dialog-close>
      <app-image-loading src="assets/icon_close.svg" alt="關閉" i18n-alt
                         [clickable]="true"
                         [targetWidth]="17"
                         [targetHeight]="17"/>
    </button>
  </div>
  <div class="title-container border-bottom center-container">
    <button class="flex-grow center-container tab-border" appFocusRemove
            [class.selected]="data.type === InfoType.PRODUCT_DETAIL"
            (click)="onTypeChange(InfoType.PRODUCT_DETAIL)">
      <span i18n>產品說明</span>
    </button>
    <button class="flex-grow center-container tab-border" appFocusRemove
            [class.selected]="data.type === InfoType.SIZE_TABLE"
            (click)="onTypeChange(InfoType.SIZE_TABLE)">
      <span i18n>商品尺寸表</span>
    </button>
    @if (data.product.fittingReportImage) {
      <button class="flex-grow center-container tab-border" appFocusRemove
              [class.selected]="data.type === InfoType.FITTING_TABLE"
              (click)="onTypeChange(InfoType.FITTING_TABLE)">
        @if (data.product.isBabyFitting) {
          <span i18n>適穿尺寸對照表</span>
        } @else {
          <span i18n>真人試穿紀錄</span>
        }
      </button>
    }
    <button class="flex-grow center-container tab-border" appFocusRemove
            [class.selected]="data.type === InfoType.RATING"
            (click)="onTypeChange(InfoType.RATING)">
      <span i18n>評價</span> ({{data.product.ratingCount}})
    </button>
  </div>
  <div #container class="content-container">
    @switch (data.type) {
      @case (InfoType.PRODUCT_DETAIL) {
        <!-- 商品說明 -->
        <div class="border-bottom info-section">
          <div class="info-title" i18n>產地及材質</div>
          <div class="desc info-margin">
            <span i18n>產地：{{data.product.origin}}</span><br/>
            <span [innerHTML]="data.product.material | newLineToHtml | safeHTML"></span>
          </div>
        </div>
        @if (data.product.productInfo; as info) {
          <div class="info-section">
            <div class="info-title">{{info.title}}</div>
            <div class="desc info-margin" [innerHTML]="info.description | newLineToHtml | safeHTML"></div>
          </div>
        }
      }
      @case (InfoType.FITTING_TABLE) {
        <!-- 真人試穿紀錄 -->
        @if (data.product.fittingReportImage; as imgObj) {
          <div class="center-container margin-top">
            <app-image-loading alt="試穿報告" i18n-alt
                               [targetWidth]="imgWidth"
                               [targetHeight]="imgWidth * imgObj.aspectRatio"
                               [src]="imgObj.hash | imageUrl: ''"
                               [clickable]="false"/>
          </div>
        }
      }
      @case (InfoType.SIZE_TABLE) {
        <!-- 商品尺寸表 -->
        @if (data.product.sizeChartImage; as imgObj) {
          <div class="column-container align-center border-bottom margin-top">
            <app-image-loading alt="尺寸表" i18n-alt
                               [targetWidth]="imgWidth"
                               [targetHeight]="imgWidth * imgObj.aspectRatio"
                               [src]="imgObj.hash | imageUrl: ''"
                               [clickable]="false"/>
            <span class="desc size-margin"
                  [style.width.px]="imgWidth"
                  [innerHTML]="data.product.sizeChartHints | hintsDisplay | newLineToHtml | safeHTML"></span>
          </div>
        }
        @for (imgObj of [data.product.firstSizeMeasurementImage, data.product.secondSizeMeasurementImage]; track imgObj) {
          @if (imgObj) {
            <div class="center-container">
              <app-image-loading alt="平放測量圖" i18n-alt
                                 [targetWidth]="imgWidth"
                                 [targetHeight]="imgWidth * imgObj.aspectRatio"
                                 [src]="imgObj.hash | imageUrl: ''"
                                 [clickable]="false"/>
            </div>
          }
        }
      }
      @case (InfoType.RATING) {
        <!-- 評價 -->
        @if (ratingsViewModel.allRatings(); as ratings) {
          @if (ratings.length) {
            <app-rating-list cdkScrollable
                             [ratingContainerWidth]="'500px'"
                             [itemWidthCss]="'640px'"
                             [allowClick]="false"
                             [horizontalPadding]="0"
                             [horizontalGap]="20"
                             [skuInfos]="ratingsViewModel.skuInfos()"
                             [productMetas]="ratingsViewModel.productMetas()"
                             [ratings]="ratings"/>
          } @else {
            <app-empty-placeholder i18n-message
                                   message="目前還沒有相關評價"
                                   src="assets/icon_product_info_comment.svg"/>
          }
        }
      }
    }
  </div>
</div>
